export const withPlural = (
  totalQuantity: number,
  singular: string,
  plural: string
) => {
  if (totalQuantity == 1) return `${totalQuantity} ${singular}`;
  else return `${totalQuantity} ${plural}`;
};
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";